import { render, staticRenderFns } from "./ContactActionsCalls.vue?vue&type=template&id=70ae12d0&scoped=true&"
var script = {}
import style0 from "./ContactActionsCalls.vue?vue&type=style&index=0&id=70ae12d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ae12d0",
  null
  
)

export default component.exports